export default __webpack_public_path__ + "static/media/Dispenser.5f9ac989.jpg";